<template>
    <div class="text-yanone flex-align-start flex-justify-between hidden-xs-up">
        <div class="filters-mobile-cr hidden-xs-up">
            <div class="flex-grid mb-1">
                <div class="flex-xs-4 cr-more-filters">
                    <div
                        v-if="showMoreFilters"
                        class="select-filter-mobile text-uppercase d-flex flex-justify-center flex-align-center"
                        @click="openFilters = !openFilters"
                    >
                        Filtros
                        <i
                            class="icon-cr icon-plus mr-1"
                            style="position: relative; right: -15%; margin-top: 1%"
                        />
                    </div>
                </div>
                <div class="flex-xs-4 cr-select">
                    <CatalogSortSelectMobile :show="showMobileSort" />
                </div>
                <div class="flex-xs-4 cr-select" v-if="displayFilterCategories">
                    <CatalogFilterGroupMobile
                        label="Temas"
                        url-param="categoria"
                        :options="storeState.filters.categories"
                        :selected="selected.category_url"
                    />
                </div>
            </div>
            <div v-if="openFilters">
                <div class="flex-grid mb-1">
                    <div class="flex-xs-4 cr-select" v-if="displayFilterTypes">
                        <CatalogFilterGroupMobile
                            label="Tipos"
                            url-param="tipo"
                            :options="storeState.filters.types"
                            :selected="selectedTypeId ? selected.type_url : undefined"
                        />
                    </div>
                    <div class="flex-xs-4 cr-select" v-if="displayFilterModels">
                        <CatalogFilterGroupMobile
                            label="Modelos"
                            url-param="modelagem"
                            :options="storeState.filters.models"
                            :selected="selected.model_url"
                        />
                    </div>
                    <div
                        class="flex-xs-4 cr-select"
                        v-if="displayFilterSizesAdult || displayFilterSizesChild"
                    >
                        <CatalogFilterGroupMobile
                            label="Tamanhos"
                            url-param="tamanho"
                            :options="storeState.filters.sizes_adult"
                            :second-options="storeState.filters.sizes_child"
                            :selected="selected.size_url"
                        />
                    </div>
                    <div class="flex-xs-4 cr-select" v-if="displayFilterColors">
                        <CatalogFilterGroupMobile
                            label="Cores"
                            url-param="cor"
                            :options="storeState.filters.colors"
                            :selected="selected.color_url"
                            :is-color="true"
                        />
                    </div>
                </div>
            </div>
            <!-- <div
                v-if="
                    selectedItems &&
                    selectedItems.length &&
                    !((selected || {}).query !== '' && (selected || {}).query != null)
                "
            >
                <div class="d-flex flex-wrap flex-item-grow mb-1">
                    <div
                        class="d-flex flex-align-center badge-selected-item mb-2 mr-2"
                        v-for="(item, index) in selectedItems"
                    >
                        <div class="d-flex flex-wrap mr-1">{{ item.name }}</div>
                        <i
                            @click="removeItem(index)"
                            class="icon-cr icon-close"
                            style="width: 0.7rem; height: 0.7rem"
                        ></i>
                    </div>
                </div>
            </div> -->

            <CatalogClearFilters :isMobile="isMobile" :selected="selected" />

            <template v-if="displayInPhysicalStock">
                <div :class="{ mr: displaySelected }" class="catalog-delivery-ready my-1 d-flex">
                    <div class="d-flex flex-align-center toggle-delivery-ready">
                        <div @click.stop.prevent="$emit('toggle-delivery-ready')" class="pt-3">
                            <input
                                id="catalog-filter-delivery-ready-desktop"
                                :checked="deliveryReadySelected"
                                class="cr-switch"
                                type="checkbox"
                            />
                            <label
                                for="catalog-filter-delivery-ready-desktop"
                                class="text-uppercase text-bold catalog-delivery-ready-text"
                                :class="[
                                    deliveryReadySelected ? 'text-accent' : '',
                                    deliveryReadySelected && !showDeliveryReadyWarning
                                        ? 'text-warning-3'
                                        : '',
                                ]"
                            >
                                {{ $t('_catalog._filter.withDeliveryReady') }}
                                <!-- <div
                                    v-show="showDeliveryReadyWarning"
                                    class="text-danger-3"
                                    style="font-size: 1rem"
                                >
                                    {{ $t('_catalog._filter.selectSize') }}
                                </div> -->
                            </label>
                        </div>
                    </div>
                </div>

                <CatalogDeliveryReady
                    v-if="deliveryReadySelected"
                    :isMobile="this.isMobile"
                    :toggleModal="showImmediateDeliveryModal"
                    :filters="filters"
                    :selected="selected"
                    :checkSelections="checkSelections"
                    @close-modal="showImmediateDeliveryModal = false"
                />

                <div
                    v-if="displaySelected"
                    class="bg-default-1 mr my-2 hidden-lg-down"
                    style="flex: 0 0 2px"
                />
            </template>
        </div>
    </div>
</template>

<script>
    import CatalogFilterGroupMobile from './CatalogFilterGroupMobile';
    import CatalogFilterGroupOption from './CatalogFilterGroupOption';
    import CatalogFilters from './CatalogFilters';
    import CatalogSortMobile from './CatalogSortMobile';
    import CatalogFilterGroupOptionColor from './CatalogFilterGroupOptionColor';
    import CatalogFilterGroupOptionSize from './CatalogFilterGroupOptionSize';
    import CatalogSortSelectMobile from './CatalogSortSelectMobile';
    import CatalogFilterGroupSelect from './CatalogFilterGroupSelect';
    import SelectField from '@bit/chicorei.chicomponents.input.select-field';
    import CatalogFilterGroupDesktop from './CatalogFilterGroupDesktop.vue';
    import CatalogClearFilters from './CatalogClearFilters';
    import CatalogDeliveryReady from './CatalogDeliveryReady';
    export default {
        name: 'CatalogFiltersSelectMobile',

        components: {
            CatalogFilterGroupOptionSize,
            CatalogFilterGroupOptionColor,
            CatalogSortMobile,
            CatalogFilterGroupOption,
            CatalogFilterGroupMobile,
            CatalogSortSelectMobile,
            SelectField,
            CatalogFilterGroupSelect,
            CatalogFilterGroupDesktop,
            CatalogClearFilters,
            CatalogDeliveryReady,
        },

        extends: CatalogFilters,

        props: {
            show: Boolean,
            showMobileSort: Boolean,
            isMobile: Boolean,
        },

        data() {
            return {
                openFilters: false,
                showImmediateDeliveryModal: false,
            };
        },

        computed: {
            // selectedItems() {
            //     let selectedItems = [];
            //     if (this.selected.type_id > 0 && this.selected.type_id <= 500) {
            //         selectedItems.push({
            //             name: this.selected.type_name,
            //             url: this.selected.type_url + '/',
            //         });
            //     }

            //     if (this.selected.category > 0) {
            //         selectedItems.push({
            //             name: this.selected.category_name,
            //             url: this.selected.category_url + '/',
            //         });
            //     }

            //     if (this.selected.model) {
            //         selectedItems.push({
            //             name: this.selected.model_name,
            //             url: this.selected.model_url + '/',
            //         });
            //     }

            //     if (this.selected.color) {
            //         selectedItems.push({
            //             name: this.selected.color_name,
            //             url: this.selected.color_url + '/',
            //         });
            //     }

            //     if (this.selected.size) {
            //         selectedItems.push({
            //             name: this.selected.size_name.replace('Tamanho', ''),
            //             url: this.selected.size_url + '/',
            //         });
            //     }

            //     return selectedItems;
            // },

            showMoreFilters() {
                if (
                    this.displayFilterTypes ||
                    this.displayFilterModels ||
                    this.displayFilterSizesAdult ||
                    this.displayFilterSizesChild ||
                    this.displayFilterColors
                ) {
                    return true;
                }
            },
        },

        mounted() {
            if (!this.checkSelections && this.deliveryReadySelected) {
                this.toggleDeliveryReady();
            }
        },

        methods: {
            removeItem(index) {
                let url = window.location.href.toString();
                let urlToRemove = this.selectedItems[index].url;

                if (this.selectedTypeId && index === 0) {
                    window.location.href = url.replace(
                        urlToRemove,
                        this.selected.type_main_url + '/'
                    );
                    return;
                }

                window.location.href = url.replace(urlToRemove, '');
            },

            checkInterruptedModal() {
                if (
                    this.deliveryReadySelected &&
                    !this.showImmediateDeliveryModal &&
                    !this.checkSelections
                ) {
                    this.toggleDeliveryReady();
                }
            },

            toggleDeliveryReady() {
                this.$emit('toggle-delivery-ready');
            },
        },

        watch: {
            deliveryReadySelected() {
                if (this.deliveryReadySelected) {
                    this.showImmediateDeliveryModal = !this.checkSelections;
                } else {
                    this.showImmediateDeliveryModal = false;
                }
            },
            showImmediateDeliveryModal() {
                this.checkInterruptedModal();
            },
            selected() {
                this.checkInterruptedModal();
            },
        },
    };
</script>